const button = "_35sbyeb6st";
const loader = "_35slt4csnz";
const progressCircle = "_35spxxacqh";
const stopIcon = "_35ss1ilhid9";

export { button, loader, progressCircle, stopIcon };
import "./_audio-player.circled.style.linaria.module.css";
//# sourceMappingURL=_audio-player.circled.style.js.map
